import { Aluminium1, Aluminium2, Aluminium3, Aluminium4, Aluminium5, Client1, Client2, Client3, Client4, Client5, Client6, Client7, Client8, Client9, Finishing1, Finishing2, Finishing3, Finishing4, Finishing5, Finishing6, Finishing7, Finishing8, Interior1, Interior2, Interior3, Portfolio1, Portfolio2, ServiceImg1, ServiceImg2, ServiceImg3, ServiceImg4, ServiceImg5, ServiceImg6, ServiceImg7, ServiceImg8, SmartHome1, SmartHome2, SmartHome3, SmartHome4, SmartHome5, SwimmingPool1, SwimmingPool10, SwimmingPool11, SwimmingPool12, SwimmingPool13, SwimmingPool14, SwimmingPool15, SwimmingPool2, SwimmingPool3, SwimmingPool4, SwimmingPool5, SwimmingPool6, SwimmingPool7, SwimmingPool8, SwimmingPool9 } from "../../ui/AllImages"
import { LazyImage } from "../../ui/Elements"

export const ServicesList1 = [
	{
		img: <LazyImage src={ServiceImg1} />,
		title: 'SLTitle1',
		txt: 'SLText1',
		listing: [ 
			{
				listTxt: 'SLList1_1',
			},
			{
				listTxt: 'SLList1_2',
			},
			{
				listTxt: 'SLList1_3',
			},
			
        ],
	},
    

]

export const ServicesList2 = [
	{
		img: <LazyImage src={ServiceImg2} />,
		title: 'SLTitle2',
		txt: 'SLText2',
		listing: [ 
			{
				listTxt: 'SLList2_1',
			},
			{
				listTxt: 'SLList2_2',
			},
			{
				listTxt: 'SLList2_3',
			},
			
        ],
	},
    

]

export const ServicesList3 = [
	{
		img: <LazyImage src={ServiceImg3} />,
		title: 'SLTitle3',
		txt: 'SLText3',
		listing: [ 
			{
				listTxt: 'SLList3_1',
			},
			{
				listTxt: 'SLList3_2',
			},
			{
				listTxt: 'SLList3_3',
			},
			
        ],
	},
    

]


export const ServicesList4 = [
	{
		img: <LazyImage src={ServiceImg4} />,
		title: 'SLTitle4',
		txt: 'SLText4',
		listing: [ 
			{
				listTxt: 'SLList4_1',
			},
			{
				listTxt: 'SLList4_2',
			},
			{
				listTxt: 'SLList4_3',
			},
			
        ],
	},
    

]

export const ServicesList5 = [
	{
		img: <LazyImage src={ServiceImg5} />,
		title: 'SLTitle5',
		txt: 'SLText5',
		listing: [ 
			{
				listTxt: 'SLList5_1',
			},
			{
				listTxt: 'SLList5_2',
			},
			{
				listTxt: 'SLList5_3',
			},
			
        ],
	},
    

]

export const ServicesList6 = [
	{
		img: <LazyImage src={ServiceImg6} />,
		title: 'SLTitle6',
		txt: 'SLText6',
		listing: [ 
			{
				listTxt: 'SLList6_1',
			},
			{
				listTxt: 'SLList6_2',
			},
			{
				listTxt: 'SLList6_3',
			},
			
        ],
	},
    

]

export const ServicesList7 = [
	{
		img: <LazyImage src={ServiceImg7} />,
		title: 'SLTitle7',
		txt: 'SLText7',
		listing: [ 
			{
				listTxt: 'SLList7_1',
			},
			{
				listTxt: 'SLList7_2',
			},
			{
				listTxt: 'SLList7_3',
			},
			
        ],
	},
    

]

export const ServicesList8 = [
	{
		img: <LazyImage src={ServiceImg8} />,
		title: 'SLTitle8',
		txt: 'SLText8',
		listing: [ 
			{
				listTxt: 'SLList8_1',
			},
			{
				listTxt: 'SLList8_2',
			},
			{
				listTxt: 'SLList8_3',
			},
			
        ],
	},
    

]




export const portfolioItems = [
    {
        id: 1,
        category: "AluminumWorks",
        img: <img className='portfolio-img' src={Aluminium1} alt="Portfolio" />,
        
    },
    {
        id: 2,
        category: "AluminumWorks",
        img: <img className='portfolio-img' src={Aluminium2} alt="Portfolio" />,
        
    },
    {
        id: 3,
        category: "AluminumWorks",
        img: <img className='portfolio-img' src={Aluminium3} alt="Portfolio" />,
        
    },
    {
        id: 4,
        category: "AluminumWorks",
        img: <img className='portfolio-img' src={Aluminium4} alt="Portfolio" />,
        
    },
    {
        id: 5,
        category: "AluminumWorks",
        img: <img className='portfolio-img' src={Aluminium5} alt="Portfolio" />,
        
    },
    

    {
        id: 41,
        category: "SwimmingPoolWorks",
        img: <img className='portfolio-img' src={SwimmingPool1} alt="Portfolio" />,
        
    },
    {
        id: 42,
        category: "SwimmingPoolWorks",
        img: <img className='portfolio-img' src={SwimmingPool2} alt="Portfolio" />,
        
    },
    {
        id: 43,
        category: "SwimmingPoolWorks",
        img: <img className='portfolio-img' src={SwimmingPool3} alt="Portfolio" />,
        
    },
    {
        id: 44,
        category: "SwimmingPoolWorks",
        img: <img className='portfolio-img' src={SwimmingPool4} alt="Portfolio" />,
        
    },
    {
        id: 45,
        category: "SwimmingPoolWorks",
        img: <img className='portfolio-img' src={SwimmingPool5} alt="Portfolio" />,
        
    },
    {
        id: 46,
        category: "SwimmingPoolWorks",
        img: <img className='portfolio-img' src={SwimmingPool6} alt="Portfolio" />,
        
    },
    {
        id: 47,
        category: "SwimmingPoolWorks",
        img: <img className='portfolio-img' src={SwimmingPool7} alt="Portfolio" />,
        
    },
    {
        id: 48,
        category: "SwimmingPoolWorks",
        img: <img className='portfolio-img' src={SwimmingPool8} alt="Portfolio" />,
        
    },
    {
        id: 49,
        category: "SwimmingPoolWorks",
        img: <img className='portfolio-img' src={SwimmingPool9} alt="Portfolio" />,
        
    },
    {
        id: 50,
        category: "SwimmingPoolWorks",
        img: <img className='portfolio-img' src={SwimmingPool10} alt="Portfolio" />,
        
    },
    {
        id: 51,
        category: "SwimmingPoolWorks",
        img: <img className='portfolio-img' src={SwimmingPool11} alt="Portfolio" />,
        
    },
    {
        id: 52,
        category: "SwimmingPoolWorks",
        img: <img className='portfolio-img' src={SwimmingPool12} alt="Portfolio" />,
        
    },
    {
        id: 53,
        category: "SwimmingPoolWorks",
        img: <img className='portfolio-img' src={SwimmingPool13} alt="Portfolio" />,
        
    },
    {
        id: 54,
        category: "SwimmingPoolWorks",
        img: <img className='portfolio-img' src={SwimmingPool14} alt="Portfolio" />,
        
    },
    {
        id: 55,
        category: "SwimmingPoolWorks",
        img: <img className='portfolio-img' src={SwimmingPool15} alt="Portfolio" />,
        
    },

    {
        id: 71,
        category: "SmartHomeSystems",
        img: <img className='portfolio-img' src={SmartHome1} alt="Portfolio" />,
        
    },
    {
        id: 72,
        category: "SmartHomeSystems",
        img: <img className='portfolio-img' src={SmartHome2} alt="Portfolio" />,
        
    },
    {
        id: 73,
        category: "SmartHomeSystems",
        img: <img className='portfolio-img' src={SmartHome3} alt="Portfolio" />,
        
    },
    {
        id: 74,
        category: "SmartHomeSystems",
        img: <img className='portfolio-img' src={SmartHome4} alt="Portfolio" />,
        
    },
    {
        id: 75,
        category: "SmartHomeSystems",
        img: <img className='portfolio-img' src={SmartHome5} alt="Portfolio" />,
        
    },
    
    {
        id: 91,
        category: "InteriorDesign",
        img: <img className='portfolio-img' src={Interior1} alt="Portfolio" />,
        
    },
    {
        id: 92,
        category: "InteriorDesign",
        img: <img className='portfolio-img' src={Interior2} alt="Portfolio" />,
        
    },
    {
        id: 93,
        category: "InteriorDesign",
        img: <img className='portfolio-img' src={Interior3} alt="Portfolio" />,
        
    },



    
]


export const clientsItems = [
    {
        img: <img className='client-img' src={Client1} alt="client" />,
    },
	{
        img: <img className='client-img' src={Client2} alt="client" />,
    },
	{
        img: <img className='client-img' src={Client3} alt="client" />,
    },
	{
        img: <img className='client-img' src={Client4} alt="client" />,
    },
	{
        img: <img className='client-img' src={Client5} alt="client" />,
    },
	{
        img: <img className='client-img' src={Client6} alt="client" />,
    },
	{
        img: <img className='client-img' src={Client7} alt="client" />,
    },
	{
        img: <img className='client-img' src={Client8} alt="client" />,
    },
	{
        img: <img className='client-img' src={Client9} alt="client" />,
    },
]

export const FaqsList = [
    {
        question: 'question1',
        answer: "answer1",
    },
    {
        question: 'question2',
        answer: "answer2",
    },
    {
        question: 'question3',
        answer: "answer3",
    },
    {
        question: 'question4',
        answer: "answer4",
    },
    {
        question: 'question5',
        answer: "answer5",
    },

]